import { Button, Collapse, Stack, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type FC, type PropsWithChildren, useState } from "react";

type Props = {
	labelCollapsed: string;
	labelExpanded: string;
	expandRequest?: number;
	collapsible?: boolean;
};

export const DisclosureSection: FC<PropsWithChildren<Props>> = ({
	labelCollapsed,
	labelExpanded,
	expandRequest = 0,
	collapsible = true,
	children,
}) => {
	const theme = useTheme();
	const [expanded, setExpanded] = useState(expandRequest > 0);
	const [previousExpandRequest, setPreviousExpandRequest] =
		useState(expandRequest);

	if (expandRequest !== previousExpandRequest) {
		setPreviousExpandRequest(expandRequest);
		if (expandRequest > 0) {
			setExpanded(true);
		}
	}

	if (!collapsible) {
		return <>{children}</>;
	}

	return (
		<Stack>
			<Collapse in={expanded} timeout="auto">
				<Stack>{children}</Stack>
			</Collapse>
			<Button
				variant="disclosure"
				aria-expanded={expanded}
				onClick={() => setExpanded((previous) => !previous)}
				endIcon={
					expanded ? (
						<ChevronUp size={theme.iconSize.sm} />
					) : (
						<ChevronDown size={theme.iconSize.sm} />
					)
				}
			>
				{expanded ? labelExpanded : labelCollapsed}
			</Button>
		</Stack>
	);
};
